<template>
  <div class="col-10">
    <slot />
  </div>
</template>
